import React, { useState, useContext, useEffect } from 'react';

import { AppContext } from '../../../../../RoutesWithAuth';

import axios from '../../../../common/AxiosConfig';

import DataGrid from '../../grid';

import { makeStyles } from "@mui/styles";

import { DATEFORMATLOCAL, DATEFORMATUTC, RequestorMapping } from '../../../../common/commons';

import RowMenuCell from '../../grid/RowEditActions';

import { LoadingIndicator } from '../../reports/reconcilationreport/MuiStyled';

import moment from 'moment';

import { Tooltip } from '@mui/material';
import { ADMIN_PERMISSIONS } from '../../../../common/RolePermissions';
import { PermissionButton } from '../../../newUI/PermissionButton'


//const Requestor = [RequestorMapping.B2B, RequestorMapping.CUSTOMER, RequestorMapping.EMPLOYEE, RequestorMapping.SURVIVOR, RequestorMapping.TCICUSTOMER];
const Requestor = {
    "b2busers": RequestorMapping.B2B, 
    "customer": RequestorMapping.CUSTOMER, 
    "employee": RequestorMapping.EMPLOYEE, 
    "survivor": RequestorMapping.SURVIVOR,
    "tcicustomer":RequestorMapping.TCICUSTOMER, 
}

// Checks without a threshold; shown as N/A and only Is Active is editable
const NON_THRESHOLD_CHECKS = [{
    pi_attribute: "Consumer Type Check",
    details: "Checks whether the request maps to an expected consumer type.",
    requestors: [RequestorMapping.CUSTOMER, RequestorMapping.TCICUSTOMER]
}, {
    pi_attribute: "Scope Duration Check",
    details: "Checks the scope duration of the request.",
    requestors: [RequestorMapping.TCICUSTOMER]
}];

const formatReviewSettings = (rows = [], requestor, workflow) => {
    const applicableChecks = workflow === "request"
        ? NON_THRESHOLD_CHECKS.filter((check) => check.requestors.includes(requestor))
        : [];

    let formattedRows = [...rows];
    applicableChecks.forEach((check) => {
        if (!rows.some((row) => row.pi_attribute === check.pi_attribute)) {
            formattedRows.push({
                pi_attribute: check.pi_attribute,
                threshold_count: "N/A",
                updated_by: "--",
                updated_on: null,
                is_active: false,
                details: check.details
            });
        }
    });

    return formattedRows
        .map((row) => {
            const isNonThresholdCheck = NON_THRESHOLD_CHECKS.some((check) => check.pi_attribute === row.pi_attribute);
            return {
                ...row,
                threshold_count: isNonThresholdCheck ? "N/A" : row.threshold_count,
                isThresholdReadOnly: isNonThresholdCheck
            };
        })
        .sort((a, b) => (a.pi_attribute || "").localeCompare(b.pi_attribute || ""));
}

const COLUMNS = [{
    name: "#",
    mapping: "rowId",
    width: 40
}, {
    name: 'PI Attribute',
    mapping: "pi_attribute",
}, {
    name: 'Threshold Count',
    mapping: "threshold_count",
    editable: true,
    width: 160,
    isHiddenForResponse: true,
    type: 'singleSelect',
    valueOptions: ['10', '20', '30'],
}, {
    name: 'Updated By',
    mapping: "updated_by",
}, {
    name: 'Updated On',
    mapping: "updated_on",
    width: 200,
    renderCell: (params) => (

        <Tooltip title={params.row["updateDateLocal"]}>
            <span>
                {params.row["updatedDateUTC"]}
            </span>
        </Tooltip>
    ),
}, {
    name: 'Is Active',
    mapping: "is_active",
    editable: true,
    width: 160,
    type: 'singleSelect',
    valueOptions: ['Yes', 'No']
}, {
    name: "Edit",
    mapping: "actions",
    adminEnabled: true,
    width: 80,
    editable: false,
    renderCell: RowMenuCell
}];
const SURVIVORCOLUMNS = [{
    name: "#",
    mapping: "rowId",
    width: 40
}, {
    name: 'PI Attribute',
    mapping: "pi_attribute",
}, {
    name: 'Threshold Count',
    mapping: "threshold_count",
    editable: true,
    width: 160,
    type: 'singleSelect',
    valueOptions: ['1', '2', '3','4','5','6','7','8','9','10'],
}, {
    name: 'Updated By',
    mapping: "updated_by",
}, {
    name: 'Updated On',
    mapping: "updated_on",
    width: 200,
    renderCell: (params) => (

        <Tooltip title={params.row["updateDateLocal"]}>
            <span>
                {params.row["updatedDateUTC"]}
            </span>
        </Tooltip>
    ),
}, {
    name: 'Is Active',
    mapping: "is_active",
    editable: true,
    width: 160,
    type: 'singleSelect',
    valueOptions: ['Yes', 'No']
}, {
    name: "Edit",
    mapping: "actions",
    adminEnabled: true,
    width: 80,
    editable: false,
    renderCell: RowMenuCell
}];

const useStyles = makeStyles(() => ({
    appscopeWrapper: {
        // marginTop: '4px',
        // marginRight: '15px'
    },
    additionalInfoWrapper: {
        marginTop: '10px',
        padding: '0px 0px 10px 0px',
        boxShadow: '0px 0px 1px 0px rgb(0 0 0 / 41%)',
        '& .headeradditional': {
            background: '#7f9ed7',
            padding: '5px',
            color: "white",
            fontWeight: 'bold'
        },
        '& .contentAdditionalInfo': {
            fontStyle: 'italic'

        }
    },
    noteWrapper: {
        marginTop: '10px',
        fontStyle: 'italic'
    }
}));
function RequestReviewTab({ activeTab, fromredirection, workflow, noteContent, activeRequestor}) {

    const [appsData, setAppsData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [additionalInfo, setAdditionalInfo] = useState("");

    const requestor = Requestor[activeRequestor] || RequestorMapping.B2B;
    //const requestor = Requestor[activeTab];
    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const classes = useStyles()
    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, activeTab, fromredirection, requestor, workflow])

    const fetchData = () => {
        setIsProcessing(true);
        const params = {
            requestor,
            workflow
        }
        axios.get(`settings/review`, {
            headers: {
                Authorization: authToken
            },
            params
        }).then(res => {
            const appsData = formatReviewSettings(res.data, requestor, workflow);
            setAppsData(appsData);
            let selection = [];
            let additRule = "";
            if (appsData.length > 0) {
                selection = [`1-${activeTab}`];
                additRule = appsData[0].details || "None";
            }
            setAdditionalInfo(additRule)
            setSelectionModel(selection);
            setIsProcessing(false);

        }).catch(err => {
            setIsProcessing(false);
            console.log(err)
        })
    }
    const updateApp = (rowInfo) => {
        setIsProcessing(true);
        const payload = {
            requestor,
            workflow,
            pi_attribute: rowInfo.pi_attribute,
            is_active: rowInfo.is_active === "Yes",
        };

        if (workflow === "request" && !rowInfo.isThresholdReadOnly) {
            payload["threshold_count"] = rowInfo.threshold_count;
        }
        
        axios.post(`settings/review`, payload, {
            headers: {
                Authorization: authToken
            }
        })
            .then(res => {
                fetchData();
                setIsProcessing(false);
            }).catch(err => {
                setIsProcessing(false);
                console.log(err)
            })
    }
    const dataGridColumns = () => {
        const isRequest = workflow === 'request';
        const permissionByRequestor = {
            [RequestorMapping.B2B]: isRequest ? ADMIN_PERMISSIONS.REQ_REVIEW_B2B_EDIT : ADMIN_PERMISSIONS.RES_REVIEW_B2B_EDIT,
            [RequestorMapping.CUSTOMER]: isRequest ? ADMIN_PERMISSIONS.REQ_REVIEW_CUSTOMER_EDIT : ADMIN_PERMISSIONS.RES_REVIEW_CUSTOMER_EDIT,
            [RequestorMapping.EMPLOYEE]: isRequest ? ADMIN_PERMISSIONS.REQ_REVIEW_EMPLOYEE_EDIT : ADMIN_PERMISSIONS.RES_REVIEW_EMPLOYEE_EDIT,
            [RequestorMapping.SURVIVOR]: isRequest ? ADMIN_PERMISSIONS.REQ_REVIEW_SURVIVOR_EDIT : undefined,
            [RequestorMapping.TCICUSTOMER]: isRequest ? ADMIN_PERMISSIONS.REQ_REVIEW_TCI_CUSTOMER_EDIT : ADMIN_PERMISSIONS.RES_REVIEW_TCI_CUSTOMER_EDIT,
        };
        const formatedColumns = [];
        if (requestor === RequestorMapping.SURVIVOR) {
            SURVIVORCOLUMNS.forEach((column) => {
                if (isRequest) {
                    formatedColumns.push(column);
                }
            })
        } else {
            COLUMNS.forEach((column) => {
                if (!(column.isHiddenForResponse && !isRequest)) {
                    formatedColumns.push(column);
                }
            })
        }
        return formatedColumns.map((column) => column.mapping === 'actions'
            ? { ...column, adminPermission: permissionByRequestor[requestor] }
            : column);
    }
    const appsGridData = () => {
        return appsData?.map((row, i) => {
            return {
                rowId: (i + 1),
                originalId: row.id,
                id: `${(i + 1)}-${activeTab}`,
                ...row,
                is_active: row.is_active ? "Yes" : "No",
                updateDateLocal: row.updated_on ? moment(row.updated_on).local().format(DATEFORMATLOCAL) : '--',
                updatedDateUTC: row.updated_on ? moment(row.updated_on).utc().format(DATEFORMATUTC) : '--',
            }
        })
    }
    return (
        <div className={classes.appscopeWrapper} key={`RequestReview-${workflow}-${activeTab}`}>
            {isProcessing && (<LoadingIndicator />)}
            <DataGrid
                disableSelectionOnClick={false}
                columns={dataGridColumns()}
                isCellEditable={(params) => {
                    if (params.field === "threshold_count" && params.row?.isThresholdReadOnly) {
                        return false;
                    }
                    return !!params.colDef.editable;
                }}
                selectionModel={selectionModel}
                onSelectionModelChange={(selection) => {
                    let gridSelection = selectionModel;
                    if (!(isProcessing || selection?.length === 0)) {
                        gridSelection = selection;
                        setSelectionModel(selection);
                    }
                    let selectedAppData = {};
                    appsData.forEach((app, index) => {
                        if (`${(index + 1)}-${activeTab}` === gridSelection[0]) {
                            selectedAppData = app;
                        }
                    })
                    !isProcessing && setAdditionalInfo(selectedAppData?.details || "None");
                }}
                rows={appsGridData()}
                onRowEditCommit={(rows, event) => {
                    if (event.rowInfo) {
                        updateApp(event.rowInfo);
                    }
                }}
            />
            {(<div className={classes.additionalInfoWrapper}>
                <div className={"headeradditional"}>
                    Details of PI Attribute check
                </div>
                <div className='contentAdditionalInfo'>
                    {additionalInfo}
                </div>
            </div>)}
            <div className={classes.noteWrapper}>
                {noteContent()}
            </div>
        </div>
    )
}
export default React.memo(RequestReviewTab);